import React from 'react';
import { Link } from 'react-router-dom';

/** Icons */
import { ReactComponent as Border } from '../../assets/svg/droplet.svg';
import { ReactComponent as Shadow } from '../../assets/svg/square.svg';
import { ReactComponent as Menu } from '../../assets/svg/triangle.svg';

const MenuItem = ({ children, to }) => {
  return (
    <li className="flex-1 xl:mx-10 mx-2">
      <Link
        to={to}
        className="w-full flex xl:flex-nowrap flex-wrap items-center justify-center cursor-pointer bg-white hover:bg-purple-900 text-purple-900 hover:text-white font-bold py-2 px-4 rounded xl:text-2xl text-center shadow-md"
      >
        {children}
      </Link>
    </li>
  );
};

const Header = () => {
  return (
    <header className="bg-gray-900 bottom-0 right-0 left-0 z-50 py-8 px-4">
      <nav className="h-full">
        <ul className="flex justify-around items-center h-full w-auto">
          <MenuItem to="/">
            <Menu className="mr-3" /> Home
          </MenuItem>
          <MenuItem to="/border-radius">
            <Border className="mr-3" /> Border Radius
          </MenuItem>
          <MenuItem to="/box-shadow">
            <Shadow className="mr-3 w-7" /> Box Shadow
          </MenuItem>
        </ul>
      </nav>
      <div
        className=" w-full text-center text-white text-sm tracking-wider"
        style={{ marginTop: '4px' }}
      >
        Powered by{' '}
        <a
          className="font-bold hover:text-indigo-300 tracking-widest"
          href="https://reactjs.org/"
        >
          React
        </a>{' '}
        and{' '}
        <a
          className="font-bold hover:text-indigo-300 tracking-widest"
          href="https://tailwindcss.com/"
        >
          TailwindCSS
        </a>{' '}
        | Icons By{' '}
        <a
          className="font-bold hover:text-indigo-300 tracking-widest"
          href="https://feathericons.com/"
        >
          Feather
        </a>
      </div>
    </header>
  );
};

export default Header;
